/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/light";

const $root = ($protobuf.roots["vip-customs"] || ($protobuf.roots["vip-customs"] = new $protobuf.Root()))
.addJSON({
  client_pb: {
    options: {
      go_package: "./client_pb"
    },
    nested: {
      GetAppraisalPointsRequest: {
        fields: {
          appraisalType: {
            type: "AppraisalType",
            id: 1
          },
          categoryType: {
            type: "CategoryType",
            id: 2
          },
          categoryId: {
            type: "int32",
            id: 3
          }
        }
      },
      GetAppraisalPointsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productCode: {
            type: "string",
            id: 3
          },
          categoryName: {
            type: "string",
            id: 4
          },
          categoryEnName: {
            type: "string",
            id: 5
          },
          categoryImage: {
            type: "string",
            id: 6
          },
          points: {
            rule: "repeated",
            type: "AppraisalPoint",
            id: 7
          },
          nonPoints: {
            rule: "repeated",
            type: "AppraisalPoint",
            id: 8
          },
          mustNum: {
            type: "int32",
            id: 9
          },
          showExtraPoints: {
            type: "bool",
            id: 10
          }
        }
      },
      GetAppraisalPointsByCodeRequest: {
        fields: {
          code: {
            type: "string",
            id: 1
          }
        }
      },
      GetAppraisalPointsByCodeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productCode: {
            type: "string",
            id: 3
          },
          categoryName: {
            type: "string",
            id: 4
          },
          categoryEnName: {
            type: "string",
            id: 5
          },
          categoryImage: {
            type: "string",
            id: 6
          },
          points: {
            rule: "repeated",
            type: "AppraisalPoint",
            id: 7
          },
          nonPoints: {
            rule: "repeated",
            type: "AppraisalPoint",
            id: 8
          },
          mustNum: {
            type: "int32",
            id: 9
          },
          showExtraPoints: {
            type: "bool",
            id: 10
          }
        }
      },
      ImageUploadRequest: {
        fields: {
          imgB64: {
            type: "string",
            id: 1
          }
        }
      },
      ImageUploadResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          imageUrl: {
            type: "string",
            id: 3
          }
        }
      },
      SingleAppraisalRequest: {
        fields: {
          pointId: {
            type: "int32",
            id: 1
          },
          imageUrl: {
            type: "string",
            id: 2
          }
        }
      },
      SingleAppraisalResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          said: {
            type: "string",
            id: 3
          },
          originalBox: {
            type: "SingleAppraisalBox",
            id: 4
          },
          detectionBox: {
            type: "SingleAppraisalBox",
            id: 5
          }
        }
      },
      AppraisalResultRequest: {
        fields: {
          code: {
            type: "string",
            id: 1
          },
          saidList: {
            rule: "repeated",
            type: "string",
            id: 2
          },
          batchCode: {
            type: "string",
            id: 3
          },
          subTaskId: {
            type: "int32",
            id: 4
          },
          productUniqueCode: {
            type: "string",
            id: 5
          },
          hangTagCode: {
            type: "string",
            id: 6
          },
          secondaryChannel: {
            type: "int32",
            id: 7
          },
          thirdChannel: {
            type: "int32",
            id: 8
          }
        }
      },
      AppraisalResultResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          oaId: {
            type: "string",
            id: 3
          }
        }
      },
      SourceTracingAppraisalRequest: {
        fields: {
          productNo: {
            type: "string",
            id: 1
          },
          tabCode: {
            type: "string",
            id: 2
          },
          imageInfo: {
            rule: "repeated",
            type: "StImageInfo",
            id: 3
          }
        }
      },
      SourceTracingAppraisalResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      SourceTracingRecordRequest: {
        fields: {}
      },
      SourceTracingRecordResqonse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          sourceTracingRecord: {
            rule: "repeated",
            type: "SourceTracingOrderItem",
            id: 3
          }
        }
      },
      SourceTracingDetailRequest: {
        fields: {
          oaidNo: {
            type: "string",
            id: 1
          }
        }
      },
      SourceTracingDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          sourceTracingRecord: {
            type: "SourceTracingOrderItem",
            id: 3
          }
        }
      },
      SourceTracingReportRequest: {
        fields: {
          qrCode: {
            type: "string",
            id: 1
          }
        }
      },
      SourceTracingReportResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          certNo: {
            type: "string",
            id: 3
          },
          result: {
            type: "int32",
            id: 4
          },
          specifications: {
            type: "string",
            id: 5
          },
          originCountry: {
            type: "string",
            id: 6
          },
          firstVisitTime: {
            type: "string",
            id: 7
          },
          lastVisitTime: {
            type: "string",
            id: 8
          },
          visitNums: {
            type: "int32",
            id: 9
          },
          productName: {
            type: "string",
            id: 10
          },
          customNo: {
            type: "string",
            id: 11
          },
          identificationImage: {
            rule: "repeated",
            type: "string",
            id: 12
          }
        }
      },
      SourceTracingVisitNumsRequest: {
        fields: {
          qrCode: {
            type: "string",
            id: 1
          }
        }
      },
      SourceTracingVisitNumsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      ComplementImagesListRequest: {
        fields: {
          oaId: {
            type: "string",
            id: 1
          }
        }
      },
      ComplementImagesListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          appraiserName: {
            type: "string",
            id: 3
          },
          appraiserAvatar: {
            type: "string",
            id: 4
          },
          categoryName: {
            type: "string",
            id: 5
          },
          categoryEnName: {
            type: "string",
            id: 6
          },
          categoryImage: {
            type: "string",
            id: 7
          },
          points: {
            rule: "repeated",
            type: "ComplementImagePoint",
            id: 8
          },
          kindId: {
            type: "int32",
            id: 9
          },
          categoryType: {
            type: "CategoryType",
            id: 10
          },
          appraisalType: {
            type: "AppraisalType",
            id: 11
          }
        },
        nested: {
          ComplementImagePoint: {
            fields: {
              name: {
                type: "string",
                id: 1
              },
              singleRecordImage: {
                type: "string",
                id: 2
              },
              pointType: {
                type: "PointType",
                id: 3
              },
              pointId: {
                type: "int32",
                id: 4
              },
              photoGuide: {
                type: "string",
                id: 5
              },
              exampleImg: {
                type: "string",
                id: 6
              },
              stickFigureImg: {
                type: "string",
                id: 7
              },
              bigStickFigureImg: {
                type: "string",
                id: 8
              },
              must: {
                type: "bool",
                id: 9
              },
              necessity: {
                type: "bool",
                id: 10
              },
              isComplementImagePoint: {
                type: "bool",
                id: 11
              },
              reason: {
                type: "string",
                id: 12
              }
            }
          }
        }
      },
      ComplementImageRequest: {
        fields: {
          oaId: {
            type: "string",
            id: 1
          },
          saId: {
            rule: "repeated",
            type: "string",
            id: 2
          }
        }
      },
      ComplementImageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      CategoryInitial: {
        fields: {
          letter: {
            type: "string",
            id: 1
          },
          categoryInfos: {
            rule: "repeated",
            type: "CategoryInfo",
            id: 2
          }
        }
      },
      CategoryInfo: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          enName: {
            type: "string",
            id: 2
          },
          images: {
            type: "ImageInfo",
            id: 3
          },
          categoryId: {
            type: "int32",
            id: 4
          },
          isEnd: {
            type: "bool",
            id: 5
          },
          hotSequence: {
            type: "int32",
            id: 6
          },
          appraisalType: {
            type: "AppraisalType",
            id: 7
          }
        }
      },
      ImageInfo: {
        fields: {
          hdImage: {
            type: "string",
            id: 1
          },
          normalImage: {
            type: "string",
            id: 2
          },
          thumbImage: {
            type: "string",
            id: 3
          }
        }
      },
      AppraisalPoint: {
        fields: {
          pointId: {
            type: "int32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          pointType: {
            type: "PointType",
            id: 3
          },
          photoGuide: {
            type: "string",
            id: 4
          },
          exampleImage: {
            type: "string",
            id: 5
          },
          stickFigureImage: {
            type: "string",
            id: 6
          },
          bigStickFigureImage: {
            type: "string",
            id: 7
          },
          must: {
            type: "bool",
            id: 8
          },
          necessity: {
            type: "bool",
            id: 9
          }
        }
      },
      SingleAppraisalBox: {
        fields: {
          x: {
            type: "string",
            id: 1
          },
          y: {
            type: "string",
            id: 2
          },
          width: {
            type: "string",
            id: 3
          },
          height: {
            type: "string",
            id: 4
          },
          radius: {
            type: "string",
            id: 5
          }
        }
      },
      SingleRecord: {
        fields: {
          saId: {
            type: "string",
            id: 1
          },
          image: {
            type: "string",
            id: 2
          },
          pointName: {
            type: "string",
            id: 3
          },
          grade: {
            type: "string",
            id: 4
          },
          description: {
            type: "string",
            id: 5
          }
        }
      },
      SourceTracingOrderItem: {
        fields: {
          oaidNo: {
            type: "string",
            id: 1
          },
          tabCode: {
            type: "string",
            id: 2
          },
          kindName: {
            type: "string",
            id: 3
          },
          brandName: {
            type: "string",
            id: 4
          },
          productName: {
            type: "string",
            id: 5
          },
          originCountry: {
            type: "string",
            id: 6
          },
          sourceTracingResult: {
            type: "int32",
            id: 7
          },
          baoguanNo: {
            type: "string",
            id: 8
          },
          stOrderNo: {
            type: "string",
            id: 9
          },
          createTime: {
            type: "string",
            id: 10
          },
          auditTime: {
            type: "string",
            id: 11
          },
          sourceTracingStatus: {
            type: "int32",
            id: 12
          },
          remark: {
            type: "string",
            id: 13
          },
          productNo: {
            type: "string",
            id: 14
          },
          sourceTracingImage: {
            rule: "repeated",
            type: "StImageInfo",
            id: 15
          }
        }
      },
      StImageInfo: {
        fields: {
          imageUrl: {
            type: "string",
            id: 1
          },
          imageName: {
            type: "string",
            id: 2
          }
        }
      },
      AppraisalType: {
        values: {
          APPRAISAL_TYPE_DEFAULT: 0,
          APPRAISAL_TYPE_AI: 1,
          APPRAISAL_TYPE_MANUAL: 2
        }
      },
      CategoryType: {
        values: {
          CATEGORY_TYPE_DEFAULT: 0,
          CATEGORY_TYPE_KIND: 1,
          CATEGORY_TYPE_BRAND: 2,
          CATEGORY_TYPE_SERIES: 3
        }
      },
      PointType: {
        values: {
          POINT_TYPE_DEFAULT: 0,
          POINT_TYPE_APPRAISAL: 1,
          POINT_TYPE_NON_APPRAISAL: 2
        }
      },
      AppraisalResult: {
        values: {
          APPRAISAL_RESULT_DEFAULT: 0,
          APPRAISAL_RESULT_TRUE: 1,
          APPRAISAL_RESULT_FALSE: 2,
          APPRAISAL_RESULT_UNKNOWN: 3
        }
      },
      ManualAppraisalResult: {
        values: {
          MANUAL_APPRAISAL_RESULT_DEFAULT: 0,
          MANUAL_APPRAISAL_RESULT_TRUE: 1,
          MANUAL_APPRAISAL_RESULT_FALSE: 2,
          MANUAL_APPRAISAL_RESULT_UNKNOWN: 3,
          MANUAL_APPRAISAL_RESULT_COMPLEMENT_IMAGE: 4
        }
      },
      CustomsEnum: {
        values: {
          CustomsEnumInit: 0,
          CustomsEnumNingBo: 1,
          CustomsEnumShangHai: 2,
          CustomsEnumZhongRen: 3,
          CustomsEnumOther: 4
        }
      },
      ChannelEnum: {
        values: {
          ChannelEnumInit: 0,
          ChannelEnumKaoLa: 1,
          ChannelEnumJingYa: 2,
          ChannelEnumTianMao: 3,
          ChannelEnumTianMaoPlatform: 4,
          ChannelEnumJDInternational: 5,
          ChannelEnumZRJD: 6,
          ChannelEnumJDInternationalYWYJ: 7,
          ChannelEnumDouyin: 8
        }
      },
      TaskProgressEnum: {
        values: {
          TaskProgressEnumInit: 0,
          TaskProgressEnumUnfinished: 1,
          TaskProgressEnumFinish: 2
        }
      },
      TaskStateEnum: {
        values: {
          TaskStateEnumInit: 0,
          TaskStateEnumEnable: 1,
          TaskStateEnumDisable: 2
        }
      },
      ComplementImageStatus: {
        values: {
          COMPLEMENT_IMAGE_STATUS_DEFAULT: 0,
          COMPLEMENT_IMAGE_STATUS_NO: 1,
          COMPLEMENT_IMAGE_STATUS_YES: 2
        }
      },
      GetKindsRequest: {
        fields: {
          appraisalType: {
            type: "AppraisalType",
            id: 1
          }
        }
      },
      GetKindsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          kinds: {
            rule: "repeated",
            type: "CategoryInfo",
            id: 3
          }
        }
      },
      GetBrandsRequest: {
        fields: {
          kindId: {
            type: "int32",
            id: 1
          },
          appraisalType: {
            type: "AppraisalType",
            id: 2
          }
        }
      },
      GetBrandsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          brands: {
            rule: "repeated",
            type: "CategoryInitial",
            id: 3
          }
        }
      },
      GetSeriesRequest: {
        fields: {
          brandId: {
            type: "int32",
            id: 1
          },
          appraisalType: {
            type: "AppraisalType",
            id: 2
          }
        }
      },
      GetSeriesResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          series: {
            rule: "repeated",
            type: "CategoryInitial",
            id: 3
          }
        }
      },
      AppraisalRecordsRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          search: {
            type: "string",
            id: 3
          },
          kindId: {
            type: "int32",
            id: 4
          },
          complementImageStatus: {
            type: "ComplementImageStatus",
            id: 5
          }
        }
      },
      AppraisalRecordsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orders: {
            rule: "repeated",
            type: "AppraisalOrder",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          AppraisalOrder: {
            fields: {
              productCode: {
                type: "string",
                id: 1
              },
              oaId: {
                type: "string",
                id: 2
              },
              coverImage: {
                type: "string",
                id: 3
              },
              createTime: {
                type: "string",
                id: 4
              },
              hierarchy: {
                type: "string",
                id: 5
              },
              kindName: {
                type: "string",
                id: 6
              },
              brandName: {
                type: "string",
                id: 7
              },
              seriesName: {
                type: "string",
                id: 8
              },
              appraisalType: {
                type: "AppraisalType",
                id: 9
              },
              result: {
                type: "AppraisalResult",
                id: 10
              },
              manualResult: {
                type: "ManualAppraisalResult",
                id: 11
              },
              batchCode: {
                type: "string",
                id: 12
              },
              secondaryChannel: {
                type: "int32",
                id: 13
              },
              complementImageStatus: {
                type: "ComplementImageStatus",
                id: 14
              },
              secondaryChannelStr: {
                type: "string",
                id: 15
              }
            }
          }
        }
      },
      AppraisalReportRequest: {
        fields: {
          oaId: {
            type: "string",
            id: 1
          }
        }
      },
      AppraisalReportResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productCode: {
            type: "string",
            id: 3
          },
          oaId: {
            type: "string",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          brandName: {
            type: "string",
            id: 6
          },
          seriesName: {
            type: "string",
            id: 7
          },
          createTime: {
            type: "string",
            id: 8
          },
          coverImage: {
            type: "string",
            id: 9
          },
          result: {
            type: "AppraisalResult",
            id: 10
          },
          manualResult: {
            type: "ManualAppraisalResult",
            id: 11
          },
          singleRecords: {
            rule: "repeated",
            type: "SingleRecord",
            id: 12
          },
          batchCode: {
            type: "string",
            id: 13
          },
          productName: {
            type: "string",
            id: 15
          },
          subTaskBrandName: {
            type: "string",
            id: 16
          },
          subTaskBarCode: {
            type: "string",
            id: 17
          },
          subTaskProductCode: {
            type: "string",
            id: 18
          },
          model: {
            type: "string",
            id: 19
          },
          customs: {
            type: "CustomsEnum",
            id: 20
          },
          channel: {
            type: "ChannelEnum",
            id: 21
          },
          taskId: {
            type: "int32",
            id: 22
          },
          subTaskId: {
            type: "int32",
            id: 23
          },
          productUniqueCode: {
            type: "string",
            id: 24
          },
          hangTagCode: {
            type: "string",
            id: 25
          },
          appraisalType: {
            type: "AppraisalType",
            id: 26
          },
          customsName: {
            type: "string",
            id: 27
          },
          channelName: {
            type: "string",
            id: 28
          }
        }
      },
      HangTagReportRequest: {
        fields: {
          qrCode: {
            type: "string",
            id: 1
          }
        }
      },
      HangTagReportResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          kindId: {
            type: "int32",
            id: 3
          },
          kindName: {
            type: "string",
            id: 4
          },
          brandId: {
            type: "int32",
            id: 5
          },
          brandName: {
            type: "string",
            id: 6
          },
          seriesId: {
            type: "int32",
            id: 7
          },
          seriesName: {
            type: "string",
            id: 8
          },
          certNo: {
            type: "string",
            id: 9
          },
          result: {
            type: "int32",
            id: 10
          },
          firstVisitTime: {
            type: "string",
            id: 11
          },
          lastVisitTime: {
            type: "string",
            id: 12
          },
          visitNums: {
            type: "int32",
            id: 13
          },
          specifications: {
            type: "string",
            id: 14
          },
          batchCode: {
            type: "string",
            id: 15
          },
          identificationImage: {
            rule: "repeated",
            type: "string",
            id: 16
          },
          appraisalResultTime: {
            type: "string",
            id: 17
          }
        }
      },
      ChannelListRequest: {
        fields: {}
      },
      ChannelListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          count: {
            type: "int32",
            id: 3
          },
          secondaryChannel: {
            rule: "repeated",
            type: "SecondaryChannelEnum",
            id: 4
          }
        }
      },
      SecondaryChannelEnum: {
        fields: {
          channelName: {
            type: "string",
            id: 1
          },
          url: {
            type: "string",
            id: 2
          },
          order: {
            type: "int32",
            id: 3
          },
          createTime: {
            type: "string",
            id: 4
          }
        }
      },
      LeaderTaskListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          }
        }
      },
      LeaderTaskListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          taskInfos: {
            rule: "repeated",
            type: "TaskInfos",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          TaskInfos: {
            fields: {
              ID: {
                type: "int32",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              },
              taskProgress: {
                type: "TaskProgressEnum",
                id: 3
              },
              customs: {
                type: "CustomsEnum",
                id: 4
              },
              channel: {
                type: "ChannelEnum",
                id: 5
              },
              warehouseName: {
                type: "string",
                id: 6
              },
              authUserCount: {
                type: "int32",
                id: 7
              }
            }
          }
        }
      },
      TaskProgressRequest: {
        fields: {
          ID: {
            type: "int32",
            id: 1
          },
          taskProgress: {
            type: "TaskProgressEnum",
            id: 2
          }
        }
      },
      TaskProgressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TaskAuthUserListRequest: {
        fields: {
          ID: {
            type: "int32",
            id: 1
          }
        }
      },
      TaskAuthUserListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          authUserInfos: {
            rule: "repeated",
            type: "AuthUserInfos",
            id: 3
          }
        },
        nested: {
          AuthUserInfos: {
            fields: {
              ID: {
                type: "int32",
                id: 1
              },
              phone: {
                type: "string",
                id: 2
              },
              note: {
                type: "string",
                id: 3
              }
            }
          }
        }
      },
      TaskAuthUserRequest: {
        fields: {
          ID: {
            type: "int32",
            id: 1
          },
          phone: {
            type: "string",
            id: 2
          },
          note: {
            type: "string",
            id: 3
          }
        }
      },
      TaskAuthUserResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      DelTaskAuthUserRequest: {
        fields: {
          authID: {
            type: "int32",
            id: 1
          },
          taskID: {
            type: "int32",
            id: 2
          }
        }
      },
      DelTaskAuthUserResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      UserTaskListRequest: {
        fields: {}
      },
      UserTaskListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          taskInfos: {
            rule: "repeated",
            type: "TaskInfos",
            id: 3
          }
        },
        nested: {
          TaskInfos: {
            fields: {
              ID: {
                type: "int32",
                id: 1
              },
              name: {
                type: "string",
                id: 2
              }
            }
          }
        }
      },
      CurrentTaskRequest: {
        fields: {
          ID: {
            type: "int32",
            id: 1
          }
        }
      },
      CurrentTaskResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          ID: {
            type: "int32",
            id: 3
          },
          name: {
            type: "string",
            id: 4
          }
        }
      },
      SubTaskListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          taskID: {
            type: "int32",
            id: 3
          },
          productName: {
            type: "string",
            id: 4
          },
          barCode: {
            type: "string",
            id: 6
          }
        }
      },
      SubTaskListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          subTaskInfos: {
            rule: "repeated",
            type: "SubTaskInfos",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          SubTaskInfos: {
            fields: {
              productName: {
                type: "string",
                id: 1
              },
              barCode: {
                type: "string",
                id: 2
              },
              taskID: {
                type: "int32",
                id: 3
              },
              subTaskID: {
                type: "int32",
                id: 4
              },
              isAppraisal: {
                type: "bool",
                id: 5
              },
              appraisalNum: {
                type: "int32",
                id: 14
              }
            }
          }
        }
      },
      GetUserPermissionRequest: {
        fields: {}
      },
      GetUserPermissionResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          permission: {
            type: "bool",
            id: 3
          },
          phone: {
            type: "string",
            id: 4
          }
        }
      }
    }
  }
});

export { $root as default };
